const baseURL = 'https://demo-multitienda.box504.com/';

export default baseURL;
